import { UIText2, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './TransportDepartmentInfo.css';

export const TransportDepartmentInfo: React.FC = () => {
  return (
    <div className={styles['container']}>
      <UIText3 color="gray60_100">Данные предоставил</UIText3>
      <UIText2 fontWeight="bold">Департамент транспорта Москвы</UIText2>
    </div>
  );
};
